module.exports = __webpack_public_path__ + "img/jppdimg_mo3.e8081271.png";